export default {
  inform: {
    profile: {
      text: 'Press the button "Unblock"',
      title: 'Application blocked',
    },
  },
}
